const originalFileFirstPathName = 'picture-origin';
const compressedFileFirstPathName = 'picture-compressed';
const compressedSizes = [
    { size: 800, type: 'md', imgSize: 768 },
    { size: 1200, type: 'lg', imgSize: 1280 }
];

const generatePictureSourceData = src => {
    const re = /(https:\/\/.+?)\/(.+?)\/(.+)\/(.+)\.(\w+)/i;
    const parsed = re.exec(src);
    if (parsed) {
        const [, origin, firstPath, restPath, filename, ext] = parsed;
        if (firstPath === originalFileFirstPathName) {
            const sources = compressedSizes.map(({ size, type }) => ({
                srcSet: `${origin}/${compressedFileFirstPathName}/${restPath}/${filename}-${type}.${ext}`,
                media: `(max-width: ${size}px)`
            }));
            return sources;
        }
    }
    return [];
};

export const createImgProp = img => {
    const { clientWidth, clientHeight } = img[0];
    const attr = {
        class: 'lazyload',
        'data-width': clientWidth,
        'data-ratio': (clientHeight / clientWidth).toFixed(3)
    };

    img.attr(attr);
};

export const setImageLazyloadStyle = (content = '') => {
    return content.replace(/<img.+?src="([^"]+)"[^>]*\/?>/gi, imgElementStr => {
        const dataWidth = (imgElementStr.match(/data-width="([\d.]+?)"/) ?? [])[1];
        const dataRatio = (imgElementStr.match(/data-ratio="([\d.]+?)"/) ?? [])[1];

        if (dataWidth && dataRatio) {
            const height = Math.round(dataWidth * dataRatio);
            imgElementStr = imgElementStr.replace(
                /<img /,
                `<img width="${dataWidth}" height="${height}" `
            );
        }

        return imgElementStr;
    });
};

export const replaceImageWithCompressed = (content = '') => {
    return content.replace(/<img.+?src="([^"]+)"[^>]*\/?>/gi, (imgElementStr, src) => {
        const sourceDatas = generatePictureSourceData(src);

        if (sourceDatas.length > 0) {
            return `
                <picture>
                    ${sourceDatas
                        .map(
                            ({ srcSet, media }) => `<source srcset="${srcSet}" media="${media}" />`
                        )
                        .join('\n')}
                    ${imgElementStr}
                </picture>
            `;
        } else return imgElementStr;
    });
};
